var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sportFootballMatchActionIconCategory"},[_c('svgicon',{attrs:{"name":_vm.icon,"original":""}}),(_vm.chance)?_c('svgicon',{attrs:{"name":"sport/football/match/scoringchance","original":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }